
import { useState, useEffect, useRef, type RefObject } from "react";

export function useContainerWidth<T extends HTMLElement>(): [
  RefObject<T | null>,
  number
] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });

    observer.observe(ref.current);

    // Set initial width
    setWidth(ref.current.getBoundingClientRect().width);

    return () => observer.disconnect();
  }, []);

  return [ref, width];
}
